export default class NotAuthenticatedException extends Error {
  constructor(message) {
    super(message)
    Error.captureStackTrace(this, this.constructor)
    this.name = 'NotAuthenticatedException'
    this.message = 'User is not authenticated.'
  }
}
